var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M12.3342 2.08594L10.8217 3.59844L14.8842 7.66094L16.3967 6.14844C17.1779 5.36719 17.1779 4.10156 16.3967 3.32031L15.1654 2.08594C14.3842 1.30469 13.1185 1.30469 12.3373 2.08594H12.3342ZM10.1154 4.30469L2.83103 11.5922C2.50603 11.9172 2.26853 12.3203 2.13728 12.7609L1.03103 16.5203C0.952908 16.7859 1.02478 17.0703 1.21853 17.2641C1.41228 17.4578 1.69666 17.5297 1.95916 17.4547L5.71853 16.3484C6.15916 16.2172 6.56228 15.9797 6.88728 15.6547L14.1779 8.36719L10.1154 4.30469Z",
          fill: "#717986",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }